import { useCallback, useRef } from 'react';

export function useElapsedTime() {
    const startTimeRef = useRef<number>(Date.now());

    const getElapsedSeconds = useCallback(
        () => Math.round((Date.now() - startTimeRef.current) / 1000),
        []
    );

    const setElapsedTimeStart = useCallback(() => {
        startTimeRef.current = Date.now();
    }, []);

    return { getElapsedSeconds, setElapsedTimeStart };
}
